import { Box } from '@tanium/react-box';
import { FormRow } from '@tanium/react-form';
import { FormSelectInput } from '@tanium/react-form-select-input';
import { Field, FieldProps, FormikErrors } from 'formik';
import get from 'lodash.get';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { TARGET_ACCESS_ID } from 'components/pages/request/requestPartials/createRequestFieldsPartials/AccessType';
import APIAccessType from 'common/IAPIAccessType';
import { K8sRoleTargetAccess } from 'gql/K8sRoleTargetAccess';
import IDropdownOption from 'common/IDropdownOption';

interface KubernetesClusterRoleProps {
  k8sTargetAccessList?: K8sRoleTargetAccess[];
}
export const ROLE = 'role';
export const NAMESPACE = 'namespace';

export const KubernetesClusterRoleAccess = ({
  k8sTargetAccessList,
}: KubernetesClusterRoleProps): React.ReactElement => {
  const { t } = useTranslation();
  const formInputIdPrefix = 'create-request-';

  const clusterRoleOptions = useCallback((): IDropdownOption[] => {
    if (k8sTargetAccessList) {
      return k8sTargetAccessList
        .filter((ta) => ta.apiAccessType === APIAccessType.CLUSTER_ROLE)
        .map((ta) => {
          return {
            label: ta.roleName,
            value: ta.id,
          };
        });
    }
    return [];
  }, [k8sTargetAccessList]);

  return (
    <Box display="inline-flex" mr={1}>
      <Field name={TARGET_ACCESS_ID}>
        {({ field, form }: FieldProps): React.ReactElement => {
          return (
            <FormRow
              label={t('CLUSTER_ROLE')}
              required
              description={t('CLUSTER_ROLE_DESCRIPTION')}
              errors={(get(form.touched, field.name) && get(form.errors, field.name)) as FormikErrors<string>}
              labelId={`${formInputIdPrefix}${field.name}`}
              data-testid={`${formInputIdPrefix}${field.name}`}
            >
              <FormSelectInput
                onChange={(option): void => {
                  void form.setFieldValue(field.name, option.value);
                  void form.setFieldValue(ROLE, option.label);
                  void form.setFieldValue(NAMESPACE, '');
                }}
                value={clusterRoleOptions().find((option) => option.value === field.value) || ''}
                inputId={`${formInputIdPrefix}${field.name}`}
                options={clusterRoleOptions()}
                aria-label={t('CLUSTER_ROLE')}
              />
            </FormRow>
          );
        }}
      </Field>
    </Box>
  );
};

export default KubernetesClusterRoleAccess;
